<template>
    <div class="dept-container">
        <Transition name="fade">
            <el-form
                v-if="formVisible"
                :inline="true"
                class="search-form"
                :model="search_data"
                label-position="top"
                style="padding: 0 20px"
            >
                <el-form-item label="用户名">
                    <el-input v-model="search_data.username" clearable placeholder="请输入" style="width: 150px" />
                </el-form-item>
                <el-form-item label="登录地址">
                    <el-input v-model="search_data.ip" clearable placeholder="请输入" style="width: 150px" />
                </el-form-item>
                <el-form-item label="登录状态">
                    <el-select v-model="search_data.status" placeholder="请选择登录状态" style="width: 165px" clearable>
                        <el-option
                            v-for="item in [
                                { name: '成功', value: 1 },
                                { name: '失败', value: 0 }
                            ]"
                            :key="item.value"
                            :label="item.name"
                            :value="Number(item.value)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作信息">
                    <el-input v-model="search_data.wd" clearable placeholder="请输入操作信息" style="width: 150px" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
        </Transition>
        <el-card shadow="never" class="noBorder">
            <template #header>
                <div class="card-header">
                    <div class="circle-btn">
                        <el-tooltip
                            class="box-item"
                            effect="dark"
                            :content="formVisible ? '隐藏搜索' : '显示搜索'"
                            placement="top"
                        >
                            <el-button plain circle @click="formVisible = !formVisible" :icon="Search" size="small"></el-button>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" content="刷新" placement="top">
                            <el-button plain circle @click="getTableData" :icon="Refresh" size="small"></el-button>
                        </el-tooltip>
                    </div>
                </div>
            </template>
            <el-table :data="table_data" border style="width: 100%">
                <el-table-column prop="username" label="用户名" width="150"></el-table-column>
                <el-table-column prop="ip" label="登陆地址"></el-table-column>
                <el-table-column prop="browser" label="浏览器"></el-table-column>
                <el-table-column prop="os" label="操作系统"></el-table-column>
                <el-table-column prop="status" label="登录状态" width="100">
                    <template #default="{ row }">
                        <el-tag v-if="row.status">成功</el-tag>
                        <el-tag type="danger" v-else>失败</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="desc" label="操作信息" width="200"></el-table-column>
                <el-table-column prop="create_time" label="登录日期" sortable width="180"></el-table-column>
                <!-- <el-table-column label="操作" fixed="right" width="240">
                    <template #default="{ row }">
                        <el-button type="primary" link :icon="Edit" @click="onEditClick(row)" v-permission="['base:post:edit']">
                            编辑
                        </el-button>
                    </template>
                </el-table-column> -->
            </el-table>

            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 50]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </el-card>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getLoginLogList } from '@/api/log.js'
import { Refresh, Search } from '@element-plus/icons'
// ElMessage

// 数据相关
const table_data = ref([{}])
const total = ref(0)
const page = ref(1)
const size = ref(10)
const search_data = ref({
    username: '',
    ip: '',
    status: '',
    ed: ''
})
// 重置
const resetQueryForm = () => {
    Object.keys(search_data.value).forEach((key) => {
        search_data.value[key] = ''
    })
    getTableData()
}
const formVisible = ref(true)
// 获取数据的方法
const getTableData = async () => {
    const result = await getLoginLogList({
        page: page.value,
        page_size: size.value,
        ...search_data.value
    })
    table_data.value = result.lists
    total.value = result.total
}

// 分页相关
/**
 * size 改变触发
 */
const handleSizeChange = (currentSize) => {
    size.value = currentSize
    getTableData()
}

/**
 * 页码改变触发
 */
const handleCurrentChange = (currentPage) => {
    page.value = currentPage
    getTableData()
}

// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getTableData()
})
</script>

<style lang="scss" scoped></style>
